import { Injectable } from '@angular/core';

/**
 * User Init Service
 *
 * Tracks whether user-initialization has completed in the current session.
 * Used by authGuard to ensure users go through /loading before accessing
 * protected routes, while allowing /setup-profile for users who need to
 * create their account document.
 *
 * In-memory only — resets on page refresh, so users re-initialize on reload.
 */
@Injectable({
  providedIn: 'root',
})
export class UserInitService {
  private _initComplete = false;

  get initComplete(): boolean {
    return this._initComplete;
  }

  setInitComplete(): void {
    this._initComplete = true;
  }

  reset(): void {
    this._initComplete = false;
  }
}
